module.exports = __webpack_public_path__ + "static/media/Back.b3d1df6d.webp";